var map = {
	"./bgg.rank.js": "5ab2",
	"./bgg.rating.js": "a17c",
	"./bgg.rating.votes.js": "49d9",
	"./bgg.weight.js": "1ee9",
	"./box.art.js": "fd19",
	"./buddies.rating.js": "2d8c",
	"./collection.added.js": "32ff",
	"./collection.updated.js": "3b28",
	"./comment.js": "2385",
	"./date.played.js": "84ea",
	"./date.rated.js": "8159",
	"./divisiveness.js": "4096",
	"./dynamic.placeholder.js": "e8f5",
	"./game.name.js": "698b",
	"./game.version.js": "73d80",
	"./group.rating.js": "ca20",
	"./insight.card.js": "dff7",
	"./insight.count.js": "f820",
	"./insight.game.js": "6558",
	"./insight.play.js": "d362",
	"./insight.rating.js": "1ff3",
	"./language.independance.js": "191f",
	"./last.played.js": "13d01",
	"./official.count.js": "0eb6",
	"./official.duration.js": "9942",
	"./play.counts.js": "1f67",
	"./play.duration.js": "c0ad",
	"./play.location.js": "23d4",
	"./play.players.js": "9e68",
	"./play.size.js": "a499",
	"./play.worth.js": "06df",
	"./rating.disparity.js": "47a6",
	"./rating.history.js": "235b",
	"./rating.js": "55de",
	"./report.js": "0886",
	"./total.hours.js": "055a",
	"./total.plays.js": "1678",
	"./users.js": "7174",
	"./win.percent.js": "8250",
	"./worth.js": "7906",
	"./year.published.js": "7d46"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc42";